import { useEffect, useState } from "react";

/** Signed URLs are display-only; callers persist the asset ID separately. */
export function MediaPreview({ mimeType, url, label, compact = false }: { mimeType: string; url: string; label: string; compact?: boolean }) {
  if (mimeType?.startsWith('image/')) return <img src={url} alt={label} loading="lazy" className="max-h-72 w-full rounded-lg bg-slate-100 object-contain" />;
  if (compact) return <span className="flex aspect-square items-center justify-center rounded-lg bg-slate-100">{mimeType?.startsWith('video/') ? 'MP4 video' : mimeType === 'application/pdf' ? 'PDF document' : 'File'}</span>;
  if (mimeType?.startsWith('video/')) return <video src={url} controls preload="metadata" aria-label={label} className="max-h-72 w-full" />;
  return <a href={url} download target="_blank" rel="noopener noreferrer" className="text-blue-700 underline">Download {mimeType === 'application/pdf' ? 'PDF' : 'file'}: {label}</a>;
}

/** Only pending images need object URLs; revoke each URL on replacement/unmount. */
export function PendingMediaPreview({ file }: { file: File }) {
  const [url, setUrl] = useState("");
  useEffect(() => {
    if (!file.type.startsWith("image/") || typeof URL.createObjectURL !== "function") return;
    const next = URL.createObjectURL(file);
    setUrl(next);
    return () => URL.revokeObjectURL(next);
  }, [file]);
  if (!file.type.startsWith("image/")) return <span>{file.type === "application/pdf" ? "PDF document" : "MP4 video"}</span>;
  return url ? <img src={url} alt={file.name} className="h-full w-full object-cover" /> : null;
}
